var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00039 0.107056C8.84743 0.107056 10.6188 0.840791 11.9249 2.14685C13.2309 3.4529 13.9647 5.2243 13.9647 7.07134C13.9647 10.0142 11.8968 13.2213 7.81467 16.7271C7.58769 16.922 7.29829 17.0291 6.99905 17.0289C6.69982 17.0286 6.4106 16.921 6.18396 16.7256L5.91396 16.4913C2.01253 13.0771 0.0361023 9.94848 0.0361023 7.07134C0.0361023 5.2243 0.769838 3.4529 2.07589 2.14685C3.38195 0.840791 5.15334 0.107056 7.00039 0.107056ZM7.00039 4.39277C6.28999 4.39277 5.60868 4.67497 5.10635 5.1773C4.60402 5.67963 4.32182 6.36094 4.32182 7.07134C4.32182 7.78174 4.60402 8.46305 5.10635 8.96538C5.60868 9.46771 6.28999 9.74991 7.00039 9.74991C7.71079 9.74991 8.3921 9.46771 8.89443 8.96538C9.39675 8.46305 9.67896 7.78174 9.67896 7.07134C9.67896 6.36094 9.39675 5.67963 8.89443 5.1773C8.3921 4.67497 7.71079 4.39277 7.00039 4.39277Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.6ab4b4696b20888555f8b985d4e952ec.svg";
export { ForwardRef as ReactComponent };